// Hook per gestire un toast semplice a livello globale
import { create } from 'zustand';

interface ToastState {
  message: string;
  type: 'info' | 'success' | 'error';
  visible: boolean;
  show: (message: string, type?: 'info' | 'success' | 'error') => void;
  hide: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  message: '',
  type: 'info',
  visible: false,
  show: (message, type = 'info') => {
    set({ message, type, visible: true });
    setTimeout(() => set({ visible: false }), 2800);
  },
  hide: () => set({ visible: false }),
}));

export const toast = {
  info: (m: string) => useToastStore.getState().show(m, 'info'),
  success: (m: string) => useToastStore.getState().show(m, 'success'),
  error: (m: string) => useToastStore.getState().show(m, 'error'),
};
